import ApplicationSerializer from 'cpc-license-manager/serializers/application';

export default class JemSerializer extends ApplicationSerializer {
  attrs = {
    features: {
      embedded: 'always',
    },
  };
}
